import { useRef } from "react";
import { EffectComposer, GodRays } from "@react-three/postprocessing";
import { BlendFunction, Resizer, KernelSize } from "postprocessing";

const Sun = () => {
  const sunRef = useRef();

  return (
    <>
      <ambientLight color={"#ded9ff"} intensity={0.2} />
      <rectAreaLight
        width={10}
        height={10}
        color={"#ded9ff"}
        intensity={1000}
        position={[-130, -4, 27]}
        lookAt={[0, 0, 0]}
        penumbra={1}
        castShadow
      />
      <mesh ref={sunRef} position={[-140, -4, 27]}>
        <sphereGeometry attach="geometry" args={[10]} />
        <meshBasicMaterial attach="material" color="white" />
      </mesh>
      {sunRef.current && (
        <EffectComposer>
          <GodRays
            sun={sunRef.current}
            blendFunction={BlendFunction.Screen}
            samples={60}
            density={0.96}
            decay={0.9}
            weight={0.4}
            exposure={0.6}
            clampMax={1}
            width={Resizer.AUTO_SIZE}
            height={Resizer.AUTO_SIZE}
            kernelSize={KernelSize.SMALL}
            blur={true}
          />
        </EffectComposer>
      )}
    </>
  );
};

export default Sun;
